import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { logoutUser, selectUser, setUser } from 'app/store/userSlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import jwtService from './services/jwtService';

const AuthContext = React.createContext();

function AuthProvider({ children }) {
  const userState = useSelector(selectUser);
  // const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(undefined);
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (!userState.isLogged) {
  //     debugger;
  //     history.push('/sign-in');
  //   } else {
  //     debugger;
  //     history.push('/');
  //   }
  // }, []);

  // useEffect(() => {
  //   // if (userState.role.length === 0 || !userState.role) {
  //   if (history.location.pathname !== '/confirmation-required') {
  //     console.log('');
  //     history.push('/sign-in');
  //   } else {
  //     // history.push('/sign-in');
  //   }
  //   // } else {
  //   //   setWaitAuthCheck(false);
  //   //   history.push('/');
  //   // }
  // }, [history.location.pathname]);

  useEffect(() => {
    jwtService.on('onAutoLogin', () => {
      /**
       * Sign in and retrieve user data with stored token
       */

      if (!userState.role || userState.role.length === 0) {
        jwtService
          .getUser()
          .then((user) => {
            if (user.roles_names) {
              localStorage.setItem('user_role', JSON.stringify(user.roles_names));
            }
            success(user, 'JWT орқали тизимга кирилди!');
            setWaitAuthCheck(false);
          })
          .catch((error) => {
            setWaitAuthCheck(false);
            pass(error.message);
          });
      }
    });

    jwtService.on('onLogin', (user) => {
      success(user, 'Тизимга кирилди!');
    });

    jwtService.on('onLogout', () => {
      pass('Тизимдан чиқилди!');

      dispatch(logoutUser());
    });

    jwtService.on('onAutoLogout', (message) => {
      pass(message);

      dispatch(logoutUser());
    });

    jwtService.on('onNoAccessToken', () => {
      pass();
    });

    jwtService.init();

    function success(user, message) {
      const roles = user.roles_names;
      // if (message) {
      //   dispatch(showMessage({ message }));
      // }
      Promise.all([
        dispatch(setUser({ role: roles, data: user })),
        // You can receive data in here before app initialization
      ]).then((values) => {
        setWaitAuthCheck(false);
        setIsAuthenticated(true);
      });
    }

    function pass(message) {
      // if (message) {
      //   dispatch(showMessage({ message }));
      // }

      setWaitAuthCheck(false);
      setIsAuthenticated(false);
    }
  }, [dispatch]);

  return waitAuthCheck ? (
    <FuseSplashScreen />
  ) : (
    <AuthContext.Provider value={{ isAuthenticated }}>{children}</AuthContext.Provider>
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
